import { Model } from 'shared/services/api/models/Model'
import { PARTICIPANT_TYPE_SHOP } from 'shared/consts/marketplace'
import {
  NewThreadMessageAttachment,
  NewThreadMessageAttachmentV1
} from './NewThreadMessageAttachment'

export interface NewThreadBodyV1 {
  files: NewThreadMessageAttachmentV1[]
  message: string
  threadId: string
  to: string[]
}

export class NewThreadBody extends Model {
  public files: NewThreadMessageAttachment[]
  public body: string
  public threadId: string
  public to: string[]

  constructor(src: NewThreadBodyV1) {
    super(src)
    this.files = src.files?.length
      ? src.files.map(
          (file: NewThreadMessageAttachmentV1) =>
            new NewThreadMessageAttachment(file)
        )
      : []
    this.body = src.message
    this.threadId = src.threadId
    this.to = src.to?.length ? src.to : [PARTICIPANT_TYPE_SHOP]
  }
}
